export enum HelpItemType {
    Category = 'category',
    Article = 'article'
}